import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5474b922"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"slide\" data-v-5474b922></div><div class=\"slide\" data-v-5474b922><div class=\"slide-part\" data-v-5474b922></div><div class=\"slide-part\" data-v-5474b922></div><div class=\"slide-part\" data-v-5474b922></div></div><div class=\"slide\" data-v-5474b922></div><div class=\"slide\" data-v-5474b922><div class=\"slide-part\" data-v-5474b922></div><div class=\"slide-part\" data-v-5474b922></div><div class=\"slide-part\" data-v-5474b922></div></div><div class=\"slide\" data-v-5474b922></div>", 5)
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/filigrane.png",
    alt: "Filigrane"
  }),
  /*#__PURE__*/_createElementVNode("h1", null, "Azura")
], -1))
const _hoisted_8 = { class: "social-links" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/icons/mail.svg",
  alt: "Mail"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.instagram.com/_azura_pro/",
  target: "_blank",
  rel: "noopener noreferrer",
  title: "Follow me on Instagram"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/icons/instagram.svg",
    alt: "Instagram"
  })
], -1))
const _hoisted_11 = { class: "btn-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("header", null, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: "/contact",
          title: "Contact me"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _hoisted_10
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        to: "/portfolio",
        title: "Portfolio",
        class: "button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Enter ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("nav", null, [
        _createVNode(_component_router_link, { to: "/contact" }, {
          default: _withCtx(() => [
            _createTextVNode("Contact")
          ]),
          _: 1
        }),
        _createTextVNode(" |  "),
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _createTextVNode("About")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}